import React from "react";
import AlberoStrutturaTopicsView from "./AlberoStrutturaTopicsView";

export default function AlberoStrutturaTopicsController({
                                                            treeData,
                                                            topicSel,
                                                        }) {

    return (
        <AlberoStrutturaTopicsView
            treeData={treeData}
            topicSel={topicSel}
        />
    );
}